const iotConfiguratorRouter = {
  path: '/iot-configurator',
  meta: {
    title: 'IotConfigurator',
    icon: 'server',
    adminOnly: true
  },
  children: [
    {
      path: 'monitoring-board',
      component: () => import('@/views/IotConfigurator/MonitoringBoard/monitoring-board'),
      // name: 'IotConfigurator',
      name: 'MonitoringBoard',
      // meta: { title: 'IotConfigurator' },
      meta: { title: 'MonitoringBoard'/*, parent: addInfo, permission: []*/, },
    },
    {
      path: 'vehicle-diagnosis',
      component: () => import('@/views/IotConfigurator/VehicleDiagnosis/vehicle-diagnosis'),
      name: 'VehicleDiagnosis',
      meta: { title: 'VehicleDiagnosis'/*, parent: addInfo , permission: ['']*/ }
    },
    {
      path: 'device-diagnosis',
      component: () => import('@/views/IotConfigurator/DeviceDiagnosis/device-diagnosis'),
      name: 'DeviceDiagnosis',
      meta: { title: 'DeviceDiagnosis' },
      hidden: true
    },
    // {
    //   path: 'device-manager',
    //   component: () => import('@/views/IotConfigurator/DeviceManager/device-manager'),
    //   name: 'DeviceManager',
    //   meta: { title: 'DeviceManager', parent: addInfo /*, permission: ['']*/ }
    // },
    // {
    //   path: 'predictive-maint',
    //   component: () => import('@/views/IotConfigurator/PredictiveMaint/predictive-maint'),
    //   name: 'PredictiveMaint',
    //   meta: { title: 'PredictiveMaint', parent: addInfo /*, permission: ['']*/ },
    // },
    // {
    //   path: 'rules-engine',
    //   component: () => import('@/views/IotConfigurator/RulesEngine/rules-engine'),
    //   name: 'RulesEngine',
    //   meta: { title: 'RulesEngine', parent: addInfo /*, permission: ['']*/ },
    // },
    // {
    //   path: 'remote-config',
    //   component: () => import('@/views/IotConfigurator/RemoteConfig/remote-config'),
    //   name: 'RemoteConfig',
    //   meta: { title: 'RemoteConfig', parent: addInfo /*, permission: ['']*/ },
    // },
  ]
}

export default iotConfiguratorRouter
